import { render } from "./WorkflowCard.vue?vue&type=template&id=1734996c&scoped=true"
import script from "./WorkflowCard.vue?vue&type=script&lang=js"
export * from "./WorkflowCard.vue?vue&type=script&lang=js"

import "./WorkflowCard.vue?vue&type=style&index=0&id=1734996c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1734996c"]])

export default __exports__